import { render } from "./CompetentionDescription.vue?vue&type=template&id=29772734&scoped=true"
import script from "./CompetentionDescription.vue?vue&type=script&lang=js"
export * from "./CompetentionDescription.vue?vue&type=script&lang=js"

import "./CompetentionDescription.vue?vue&type=style&index=0&id=29772734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29772734"]])

export default __exports__